/**
 * TermsPage.js — Web /terms route.
 *
 * Copy is read from the single source of truth at `../legal/legalContent` so
 * the web in-app page, the static `/terms.html` (generated), and the mobile
 * in-app screen (generated) can never drift. To edit the terms text, change
 * `src/legal/legalContent.js` then run `node scripts/gen-legal-html.js`.
 */
import LegalDoc from '../components/legal/LegalDoc';
import { TERMS } from '../legal/legalContent';

export default function TermsPage() {
  return (
    <LegalDoc
      doc={TERMS}
      testId="terms-page"
      otherLink={{ href: '/privacy', label: 'Privacy Policy' }}
    />
  );
}
